// Arquivados e fixados (0.65): padrão único em todas as abas.
// Arquivar NÃO apaga: o item sai da lista principal e vai para "📦 Arquivados (N)", no fim da lista.
// Fixar no topo ⭐: o item aparece primeiro na lista dele. As marcas ficam num documento só ("organizar"),
// pela chave "aba:id", e sincronizam entre os aparelhos como o resto.
import { getDoc, setDoc, useDoc } from '../store/store';
import type { AbaId } from '../store/types';
import { oferecerDesfazer } from './desfazer';

const k = (aba: AbaId | string, id: string) => `${aba}:${id}`;
const agora = () => new Date().toISOString();

export const estaArquivado = (aba: AbaId | string, id: string) => !!getDoc('organizar').arq?.[k(aba, id)];
export const estaFixado = (aba: AbaId | string, id: string) => !!getDoc('organizar').fix?.[k(aba, id)];

export function arquivar(aba: AbaId | string, ids: string | string[]) {
  const l = Array.isArray(ids) ? ids : [ids];
  setDoc('organizar', d => { const arq = { ...(d.arq ?? {}) }; for (const id of l) arq[k(aba, id)] = agora(); return { ...d, arq }; });
  // 0.67 (C2): "📦 Item arquivado · Desfazer" por 5 segundos
  for (const id of l) oferecerDesfazer('arquivar', () => restaurar(aba, id));
}
export function restaurar(aba: AbaId | string, ids: string | string[]) {
  const l = Array.isArray(ids) ? ids : [ids];
  setDoc('organizar', d => { const arq = { ...(d.arq ?? {}) }; for (const id of l) delete arq[k(aba, id)]; return { ...d, arq }; });
}
export function alternarFixo(aba: AbaId | string, id: string) {
  setDoc('organizar', d => { const fix = { ...(d.fix ?? {}) }; if (fix[k(aba, id)]) delete fix[k(aba, id)]; else fix[k(aba, id)] = agora(); return { ...d, fix }; });
}
/** Esquece as marcas de um item excluído de vez. */
export function esquecer(aba: AbaId | string, id: string) {
  const o = getDoc('organizar');
  if (!o.arq?.[k(aba, id)] && !o.fix?.[k(aba, id)]) return;
  setDoc('organizar', d => { const arq = { ...(d.arq ?? {}) }, fix = { ...(d.fix ?? {}) }; delete arq[k(aba, id)]; delete fix[k(aba, id)]; return { ...d, arq, fix }; });
}

/** Na tela: separa a lista em ativos (fixados primeiro) e arquivados. */
export function useOrganizar(aba: AbaId | string) {
  const o = useDoc('organizar');
  const arquivado = (id: string) => !!o.arq?.[k(aba, id)];
  const fixado = (id: string) => !!o.fix?.[k(aba, id)];
  function separar<T>(lista: T[], idDe: (x: T) => string, podeFixar: (x: T) => boolean = () => true) {
    const ativos = lista.filter(x => !arquivado(idDe(x)));
    const fixos = ativos.filter(x => podeFixar(x) && fixado(idDe(x)));
    const outros = ativos.filter(x => !(podeFixar(x) && fixado(idDe(x))));
    return { ativos: [...fixos, ...outros], arquivados: lista.filter(x => arquivado(idDe(x))), fixos: fixos.length };
  }
  return { arquivado, fixado, separar,
    arquivar: (id: string | string[]) => arquivar(aba, id), restaurar: (id: string | string[]) => restaurar(aba, id), alternarFixo: (id: string) => alternarFixo(aba, id) };
}
